import { z } from 'zod';

export const LoginDto = z.object({
  email: z.string().min(1),
  password: z.string().min(1),
});

export type LoginDto = z.infer<typeof LoginDto>;

export const SSOAuthTokenDto = z.object({
  id_token: z.string().min(1),
  access_token: z.string().min(1),
  refresh_token: z.string().min(1),
});

export type SSOAuthTokenDto = z.infer<typeof SSOAuthTokenDto>;

export const ForgotPasswordDto = z.object({
  email: z.string().min(1),
});

export type ForgotPasswordDto = z.infer<typeof ForgotPasswordDto>;

export const ResetPasswordDto = z.object({
  email: z.string().min(1),
  resetToken: z.string().min(1),
  newPassword: z.string().min(1),
});

export type ResetPasswordDto = z.infer<typeof ResetPasswordDto>;

export const ResetPasswordSuccessDto = z.object({
  email: z.string().min(1),
});

export type ResetPasswordSuccessDto = z.infer<typeof ResetPasswordSuccessDto>;

export const GenerateLoginLinkDto = z.object({
  domainHint: z.string().min(1),
  redirectUri: z.string().min(1),
});

export type GenerateLoginLinkDto = z.infer<typeof GenerateLoginLinkDto>;

export const GenerateLogoutLinkDto = z.object({
  logoutUri: z.string().min(1),
});

export type GenerateLogoutLinkDto = z.infer<typeof GenerateLogoutLinkDto>;

export const LoginLinkDto = z.object({
  link: z.string().min(1),
});

export type LoginLinkDto = z.infer<typeof LoginLinkDto>;

export const LogoutLinkDto = z.object({
  link: z.string().min(1),
});

export type LogoutLinkDto = z.infer<typeof LogoutLinkDto>;

export const AccessTokenValiditySeconds = 60 * 60;
export const RefreshTokenValiditySeconds = 24 * 60 * 60;
export const SharedAccessTokenValiditySeconds = 60 * 60 * 6;
export const AccessTokenCookieName = 'access_token';
export const RefreshTokenCookieName = 'refresh_token';
export const ClientIdCookieName = 'client_id';
export const SharedAccessTokenCookieName = 'shared_access_token';

export const buildCookieSecretName = (stackIdentifier: string) =>
  `sigma-squared-${stackIdentifier}-cookie-secret`;

export const buildSharedJwtSecretName = (stackIdentifier: string) =>
  `sigma-squared-${stackIdentifier}-shared-jwt-secret`;

export const SharedAccessResourceType = z.enum(['dashboard']);
export type SharedAccessResourceType = z.infer<typeof SharedAccessResourceType>;

export const SharedAccessResourceDto = z.object({
  accessType: z.enum(['user', 'shared', 'public', 'none']),
  hasAccess: z.boolean(),
});

export type SharedAccessResourceDto = z.infer<typeof SharedAccessResourceDto>;
